import { isAllDay } from './time';

export function fmt(n) {
  return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtMonthDay(iso) {
  const d = new Date(iso + 'T00:00:00');
  return { mo: d.toLocaleDateString('en-US', { month: 'short' }), dy: d.getDate() };
}

export function fmtTime(t) {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')}${period}`;
}

/* An event's time range ("9:00AM–10:00AM"), or "All day" for the 09:00–23:59 pair. */
export function fmtEventTime(startTime, endTime) {
  if (!startTime) return '';
  if (isAllDay(startTime, endTime)) return 'All day';
  return `${fmtTime(startTime)}${endTime ? '–' + fmtTime(endTime) : ''}`;
}

/* A day off reads "Mon, Oct 12", or "Mon, Nov 23 to Fri, Nov 27" for a break.
   Noon keeps the weekday right on either side of a DST change. */
export function fmtNoSchoolDates(date, endDate) {
  const f = (iso) =>
    new Date(iso + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  return endDate && endDate > date ? `${f(date)} to ${f(endDate)}` : f(date);
}

/* How many days a day off covers — 1 unless it has a later last day. */
export function noSchoolDayCount(date, endDate) {
  if (!endDate || endDate <= date) return 1;
  return Math.round((new Date(endDate + 'T12:00:00') - new Date(date + 'T12:00:00')) / 864e5) + 1;
}

export function fmtDateTime(iso) {
  const d = new Date(iso);
  return (
    d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) +
    ' at ' +
    d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  );
}

export function sourceEmoji(s) {
  return { Venmo: '📱', 'Apple Pay': '📱', Check: '🧾', Cash: '💵', Other: '❓' }[s] || '💵';
}

export function kidAge(dob) {
  const b = new Date(dob + 'T00:00:00');
  const t = new Date();
  let a = t.getFullYear() - b.getFullYear();
  const m = t.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && t.getDate() < b.getDate())) a--;
  return a < 1 ? '<1' : a;
}

/* Today in the viewer's own timezone. Every date this app compares it against
   (event dates, donation dates, schedule dates) is built from local parts, so
   toISOString() — which is UTC — would call it tomorrow all evening west of
   Greenwich and hide today's events. */
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/* Remaining time as m:ss for countdowns ("Resend in 1:59"). Rounds up, so the
   display never shows 0:00 while the lock is still on. */
export function fmtCountdown(ms) {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/* Birthday inputs are free-typed mm/dd/yyyy text (the native calendar picker is
   painful for a date years back). Stored values stay ISO (yyyy-mm-dd). */
export function formatBdayInput(value) {
  const digits = String(value || '').replace(/[^0-9]/g, '').slice(0, 8);
  if (digits.length > 4) return digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
  if (digits.length > 2) return digits.slice(0, 2) + '/' + digits.slice(2);
  return digits;
}

export function bdayToISO(str) {
  const m = String(str || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return '';
  return `${m[3]}-${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}`;
}
